export default __webpack_public_path__ + "static/media/1257.74eddd71.png";